import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.tsx';
import { handleLiffState } from './utils/handleLiffState';

// LIFF状態パラメータを処理
// リダイレクト中はReactのレンダリングをスキップ
let isRedirecting = false;
try {
  isRedirecting = handleLiffState();
} catch (e) {
  console.error(
    '[LIFF] URL状態処理で予期しないエラーが発生しました。通常レンダリングで続行します。',
    e
  );
}

if (!isRedirecting) {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
}
